import React, {useEffect} from "react"
import {connect, useDispatch, useSelector} from "react-redux"
import {createData} from "../action/action"
import Display from "./display/display"
import Upload from "./upload/upload"
import Styles from "./uploadAndDisplay.less"

const UploadAndDisplay = (props: any) => {
    const dispatch = useDispatch()
    const claData = useSelector((state: any) => state.claData)

    const renderUploadOrDisplay = () => {
        switch (props.uploadOrDisplay) {
            case "upload":
                return <Upload />
            case "display":
                return <Display />
            default:
        }
    }
    return <div className={Styles.UploadAndDisplay}>{renderUploadOrDisplay()}</div>
}

export default connect((state: any) => {
    return {
        uploadOrDisplay: state.uploadOrDisplay,
    }
})(UploadAndDisplay)
